var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// defs
import { KeywordMatchType } from '@local/typedefs/dist/protos/campaign/Criteria';
// constants
import { KeywordTableTitles } from './constants';
import { CampaignWriteTooltips } from '@/constants/tooltips';
// includes
import { fetchSuggestedKeywordsApi } from '@/includes/api/keywords/suggestions';
// stores
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
export const getMatchTypeString = (matchType) => {
    switch (matchType) {
        case KeywordMatchType.KEYWORD_MATCH_TYPE_BROAD:
            return 'Broad Match';
        case KeywordMatchType.KEYWORD_MATCH_TYPE_EXACT:
            return 'Exact Match';
        case KeywordMatchType.KEYWORD_MATCH_TYPE_INVALID:
        default:
            return '-';
    }
};
export const getTableHeaderTooltipAndText = (title) => {
    const showTooltip = [
        KeywordTableTitles.TABLE_HEADERS.MINIMUM_BID,
        KeywordTableTitles.TABLE_HEADERS.MATCH_TYPE,
        KeywordTableTitles.TABLE_HEADERS.YOUR_BID,
    ].includes(title);
    const tooltipText = title === KeywordTableTitles.TABLE_HEADERS.MINIMUM_BID
        ? CampaignWriteTooltips.KEYWORD_MINIMUM_BID
        : title === KeywordTableTitles.TABLE_HEADERS.MATCH_TYPE
            ? CampaignWriteTooltips.KEYWORD_MATCH_TYPE
            : title === KeywordTableTitles.TABLE_HEADERS.YOUR_BID
                ? CampaignWriteTooltips.KEYWORD_BID
                : '';
    return {
        tooltipText,
        showTooltip,
    };
};
export const checkIfKeywordExists = (suggestedKeywords, keywordText) => {
    return suggestedKeywords.find((selectedKeyord) => selectedKeyord.keywordText === keywordText);
};
export const checkIfKeywordAlreadySelected = (selectedKeywords, keywordText) => {
    return selectedKeywords.find((selectedKeyord) => selectedKeyord.keywordText === keywordText);
};
export const fetchSuggestedKeywordsHelper = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const suggestedKeywordsResult = yield fetchSuggestedKeywordsApi({
            candidateIds: params.candidateIds,
            placementIds: params.placementIds,
            adUnitType: params.adUnitType,
            accountId: params.accountId,
        });
        return Array.isArray(suggestedKeywordsResult) &&
            suggestedKeywordsResult.length
            ? suggestedKeywordsResult
            : [];
    }
    catch (err) {
        return [];
    }
});
export const fetchSelectedSuggestedKeywordsHelper = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const preSelectedKeywordsText = params.mode === CampaignWriteModeEnum.EDIT
        ? params.preSelectedKeywords.map((keyword) => keyword.keywordText)
        : [];
    const selectedKeywordsText = params.selectedKeywords.map((keyword) => keyword.keywordText);
    const keywordsText = [
        ...selectedKeywordsText,
        ...preSelectedKeywordsText,
    ].filter((keywordText) => {
        return !checkIfKeywordExists(params.suggestedKeywords, keywordText);
    });
    if (!keywordsText.length) {
        return [];
    }
    try {
        const selectedKeywordSuggestions = yield fetchSuggestedKeywordsApi({
            candidateIds: params.candidateIds,
            placementIds: params.placementIds,
            adUnitType: params.adUnitType,
            keywords: keywordsText,
            accountId: params.accountId,
        });
        if (!(Array.isArray(selectedKeywordSuggestions) &&
            selectedKeywordSuggestions.length)) {
            return [];
        }
        const filteredKeywords = selectedKeywordSuggestions.filter(({ keywordText: selectedKeywordText }) => !params.suggestedKeywords.find(({ keywordText }) => keywordText === selectedKeywordText));
        return filteredKeywords;
    }
    catch (err) {
        // TODO: error handling
        return [];
    }
});
